export enum TAB_INDEXES {
  HOLIDAYS = 0,
  ESCORTED_TOURS = 1,
  PRIVATE_TOURS = 2,
  SOLO_TOURS = 3,
  MULTI_CENTRE = 4,
  RIVER_CRUISES = 5,
  CRUISES = 6
}
